import React from 'react';

import { Typography } from '@mui/material';

import { Chapters } from '../transcriptTypes';

export const TranscriptSentenceImportantPhrases = ({ sentence }: { sentence: Chapters }) => {
  return (
    <>
      <Typography variant="h4" color="grey.500" mb={2}>
        {sentence.headline}
      </Typography>
      <Typography variant="text2">{sentence.summary}</Typography>
    </>
  );
};
